import ScrollToTop from '../Components/ScrollToTop';
import HeroSection from '../Components/HeroSection/index';
import Slider from '../Components/Slider/Slider';
import Infosection from '../Components/Infosection/Index';
import { homeObjOne } from '../Components/Infosection/Data'
import Contact from '../Components/Contact/Contact';
import Footer from '../Components/Footer/Footer';

const Index = () => {
  return (
    <>
        <ScrollToTop />
        <HeroSection /> 
        <Slider />
        <Infosection {...homeObjOne} />
        <Contact />
        <Footer />
    </>
  )
}

export default Index